import {
    createFailure,
    validationFailed,
    ValidationFailure,
    ValidationResult,
    validationSuccessful
} from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../../common/types/DeliveryEndpointType";
import { hasFileExtension } from "../utils/hasFileExtension";

export const validateTargetFileName = (
    targetFileName: string,
    deliveryType?: DeliveryEndpointType
): ValidationResult => {
    const failures: ValidationFailure[] = [];

    if (!hasFileExtension(targetFileName)) {
        const failure = createFailure(
            "Target file name should contain extension",
            "targetFileName.MissingFileExtension"
        );

        failures.push(failure);
    }

    if (targetFileName?.includes("/")) {
        const failure = createFailure("Target file name shouldn't contain '/'", "targetFileName.ContainsDirectoryChar");

        failures.push(failure);
    }

    if (deliveryType === DeliveryEndpointType.Smartjog && targetFileName?.includes(" ")) {
        failures.push(createFailure("Target file name shouldn't contain spaces", "targetFileName.ContainsSpaces"));
    }

    if (failures.length) {
        return validationFailed(failures);
    }

    return validationSuccessful();
};
